<div *ngIf="podeVerbotaoAvatar" class="dropdown btn-group">
	<button id="button-alignment" class="btn-user-us" type="button" [matMenuTriggerFor]="menu">
		<span>{{gerarIniciaisNome()}}</span>
	</button>
  <mat-menu #menu="matMenu">
    <button mat-menu-item (click)="authService.logout()">Sair</button>
    <span mat-menu-item>V: {{version}}</span>
  </mat-menu>
</div>
